export default __webpack_public_path__ + "static/media/score.e622f183.mp4";